export async function init(element) {
	const wrapper = element.querySelector('.swiper-wrapper');

	if (wrapper.children.length === 1)
		return;

	const { default: Swiper } = await import('swiper/bundle');
	const buttonNext = element.querySelector('.swiper-button-next-custom');
	const buttonPrev = element.querySelector('.swiper-button-prev-custom');
	const paginationElement = element.querySelector('.swiper-pagination');
	const delay = Number(element.dataset.autoplayDelay);
	const autoplay = {
		...(delay ? { delay } : {}),
	};
	const pagination = {
		el: paginationElement,
		type: 'bullets',
	};
	const navigation = {
		nextEl: buttonNext,
		prevEl: buttonPrev,
	};

	return new Swiper(element, {
		slidesPerView: 1,
		loop: false,
		...(delay ? { autoplay } : {}),
		navigation,
		pagination,
	});
}

export async function initAll([element, ...elements]) {
	if (element)
		await init(element);

	if (elements.length)
		return await initAll(elements);
}

document.addEventListener('DOMContentLoaded', () => initAll(document.querySelectorAll('.banner-carousel')));
